import {useAuth} from '#imports';

export function useLegalEntityEditionRights() {
    const {user, hasEnoughPrivilege} = useAuth();

    function hasLegalEntityEditionRights(organizationId: string) {
        if (hasEnoughPrivilege(['ROLE_ADMIN'])) return true;
        const organizationRights = user?.organizationMemberDetails?.find((memberDetail) => memberDetail.organizationId === organizationId);
        return organizationRights?.userMayEditLegalEntityDetails;
    }
    return {
        hasLegalEntityEditionRights,
    };
}
